import { Attributes, EnumHelper, ModelBase, Rules, Validation } from '@singularsystems/neo-core';

export default class NoteType extends ModelBase {
    static typeName = "NoteType";

    constructor() {
        super();
        this.makeObservable();
    }

    public noteTypeId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Note Type")
    public noteTypeName: string = "";

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<NoteType>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.noteTypeName) {
            return "New note type";
        } else {
            return this.noteTypeName;
        }
    }
}

export enum SystemNoteType {
    InvestorPaymentDateReminder = -1,
    IssuerPaymentDateReminder = -2,
    InvestorEndDateReminder = -3,
    IssuerEndDateReminder = -4,
    DwtExpiryDateReminder = -5,
}

EnumHelper.decorateEnum(SystemNoteType, decorator => {
    decorator.describe(SystemNoteType.InvestorPaymentDateReminder, "Investor Investment Payments");
    decorator.describe(SystemNoteType.IssuerPaymentDateReminder, "Issuer Investment Payments");
    decorator.describe(SystemNoteType.InvestorEndDateReminder, "Investor Investment End");
    decorator.describe(SystemNoteType.IssuerEndDateReminder, "Issuer Investment End");
    decorator.describe(SystemNoteType.DwtExpiryDateReminder, "DWT Expiry");
});